"use client";

import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { useEffect } from "react";
import SuspendedPostHogPageView from "../PostHogPageView";
import { useAuth } from "./auth-context";

export function PHProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
      api_host: "/ingest",
      ui_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
      // Share the anonymous id with the marketing site (studygenie.io) so
      // pre-signup browsing there merges into the identified user here.
      cross_subdomain_cookie: true,
      capture_pageview: false, // Disable automatic pageview capture, as we capture manually
      capture_pageleave: true, // Enable pageleave capture
      session_recording: {
        maskAllInputs: false,
        maskInputOptions: {
          password: true, // Highly recommended as a minimum!!
          // color: false,
          // date: false,
          // 'datetime-local': false,
          // email: false,
          // month: false,
          // number: false,
          // range: false,
          // search: false,
          // tel: false,
          // text: false,
          // time: false,
          // url: false,
          // week: false,
          // textarea: false,
          // select: false,
        },
      },
    });
  }, []);

  return (
    <PostHogProvider client={posthog}>
      <SuspendedPostHogPageView />
      <PostHogAuthWrapper>{children}</PostHogAuthWrapper>
    </PostHogProvider>
  );
}

function PostHogAuthWrapper({ children }: { children: React.ReactNode }) {
  const { session } = useAuth();

  useEffect(() => {
    if (session?.user) {
      posthog.identify(session.user.id, {
        email: session.user.email,
        metadata: session.user.user_metadata,
        firstSeen: session.user.created_at,
      });
    }
    // No reset() for logged-out visitors: wiping the anonymous id on every
    // logged-out render destroyed marketing-site -> app attribution. Reset
    // happens on SIGNED_OUT in auth-context instead.
  }, [session]);

  return children;
}
